import { ReactNode } from "react";

import { ChildrenArea, InnerChildrenArea, WrappedButtonArea } from "./StickyAreaStyles";

interface IStickyAreaProps {
  children?: ReactNode;
  fullWidth?: boolean;
  intenseGradient?: boolean;
}

export const StickyArea = ({ children, fullWidth = false, intenseGradient = false }: IStickyAreaProps) => {
  return (
    <WrappedButtonArea data-testid="stickyArea">
      <ChildrenArea data-testid="stickyChildrenArea" $fullWidth={fullWidth} $intenseGradient={intenseGradient}>
        <InnerChildrenArea $fullWidth={fullWidth}>{children}</InnerChildrenArea>
      </ChildrenArea>
    </WrappedButtonArea>
  );
};
